// hubspot-api.js
class HubspotApi {
  getApiKey() {
    return process.env.REACT_APP_CORAL_SERVICE_API_KEY;
  }

  getBaseUrl() {
    return process.env.REACT_APP_CORAL_SERVICE_BASE_URL;
  }

  async request(endpoint, organizationId, options = {}) {
    const base = this.getBaseUrl();
    const url = new URL(base + endpoint, base);

    const { params, headers, ...rest } = options;
    if (params && typeof params === 'object') {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          url.searchParams.set(key, String(value));
        }
      });
    }

    try {
      const response = await fetch(url.toString(), {
        ...rest,
        headers: {
          'Content-Type': 'application/json',
          'x-org-id': organizationId,
          'x-api-key': this.getApiKey(),
          ...headers,
        },
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Request failed' }));
        throw new Error(error.message || `HTTP ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`HubSpot API Error: ${endpoint}`, error);
      throw error;
    }
  }

  // Get current HubSpot integration status for an organization
  async getStatus(organizationId) {
    return this.request('/integrations/hubspot/status', organizationId);
  }

  // Link organization to HubSpot by setting Hub ID
  async linkOrg(organizationId, hubspotHubId) {
    return this.request('/integrations/hubspot/link-org', organizationId, {
      method: 'POST',
      body: JSON.stringify({ hubspotHubId }),
    });
  }

  // Get the HubSpot OAuth install URL
  async getInstallUrl(organizationId) {
    return this.request('/integrations/hubspot/install-url', organizationId);
  }

  // Get contacts for a specific HubSpot company
  async getCompanyContacts(organizationId, companyId) {
    return this.request(`/integrations/hubspot/companies/${companyId}/contacts`, organizationId);
  }
}

export default new HubspotApi();
